var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLulaLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1914 7.9487L4.21826 18.1929L7.88597 21.6169L18.8591 11.3728L15.1914 7.9487Z",
    fill: "#0F253B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1802 0.0806902L0 14.2524L3.6677 17.6765L18.8479 3.50474L15.1802 0.0806902Z",
    fill: "#0F253B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1187 12.3234L3.93848 26.4951L7.60618 29.9192L22.7864 15.7474L19.1187 12.3234Z",
    fill: "#0F253B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLulaLogoDark);
export default __webpack_public_path__ + "static/media/lula-logo-dark.ef7dbbc92fcb439fdd5f1c837ba59d1b.svg";
export { ForwardRef as ReactComponent };